import { useEffect, useRef } from "react";
import type { RemoteAudioTrack, RemoteVideoTrack } from "livekit-client";

interface VideoProps {
  track: RemoteVideoTrack;
  fit?: "cover" | "contain";
}

/// Attaching only visible tiles lets LiveKit adaptive streaming pause off-page candidates
/// and pick a low simulcast layer for small tiles.
export const CandidateVideo = ({ track, fit = "cover" }: VideoProps) => {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    track.attach(el);
    return () => {
      track.detach(el);
    };
  }, [track]);

  return (
    <video
      ref={ref}
      autoPlay
      playsInline
      muted
      data-testid="proctor-video"
      style={{ width: "100%", height: "100%", objectFit: fit, background: "#000", display: "block" }}
    />
  );
};

export const CandidateAudio = ({ track }: { track: RemoteAudioTrack }) => {
  const ref = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    track.attach(el);
    return () => {
      track.detach(el);
    };
  }, [track]);

  return <audio ref={ref} autoPlay />;
};
